import { render, staticRenderFns } from "./certificateAddSearchModal.vue?vue&type=template&id=6403f1c0&scoped=true&"
import script from "./certificateAddSearchModal.vue?vue&type=script&lang=js&"
export * from "./certificateAddSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./certificateAddSearchModal.vue?vue&type=style&index=0&id=6403f1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403f1c0",
  null
  
)

export default component.exports